module.exports = __webpack_public_path__ + "img/ball_2_transparent.ef4734ec.png";